import { reduxStoreTypes } from '@/type/redux-store';

export const SET_GLOBAL_REPORT: reduxStoreTypes.GlobalReportType = 'SET_GLOBAL_REPORT';
export const GET_GLOBAL_REPORT: reduxStoreTypes.GlobalReportType = 'GET_GLOBAL_REPORT';
export const setGlobalReport = (params: Omit<reduxStoreTypes.GlobalReportAction, 'type'>) => ({
    type: SET_GLOBAL_REPORT,
    ...params
})

export const getGlobalReport = (params: Omit<reduxStoreTypes.GlobalReportAction, 'type'>) => ({
    type: GET_GLOBAL_REPORT,
    ...params
})